import { FormControl, OutlinedInput } from "@material-ui/core";
import EmojiPicker from "Components/formControls/Popovers/EmojiPicker";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useStyles } from "./styles";

const TextFieldInput = ({ commentText }) => {
  const classes = useStyles();
  const { register, control, watch, setValue } = useFormContext();
  // const { commentText } = watch();
  const addEmoji = (emoji) => setValue("commentText", commentText + emoji);
  return (
    <FormControl variant="outlined">
      <Controller
        register={register("commentText")}
        name="commentText"
        control={control}
        render={({ field }) => {
          const { onChange } = field;
          return (
            <OutlinedInput
              // multiline
              autoComplete="off"
              placeholder="Type your comments..."
              color="secondary"
              value={commentText}
              className={classes.textBox}
              id="outlined-adornment-weight"
              startAdornment={
                <EmojiPicker comment={commentText} addEmoji={addEmoji} />
              }
              aria-describedby="comment"
              inputProps={{
                "aria-label": "comment",
              }}
              labelWidth={0}
              onChange={onChange}
            />
          );
        }}
      />
    </FormControl>
  );
};
export default TextFieldInput;
